.root {
  display: var(--haus-stockStatus__root__display, flex);
  align-items: var(--haus-stockStatus__root__align-items, center);
  gap: var(--haus-stockStatus__root__gap, var(--haus-spacing-xs, 8px));
}

.dotInStock,
.dotLowStock,
.dotOutOfStock {
  flex-shrink: var(--haus-stockStatus__dot__flex-shrink, 0);
}

.dotInStock circle {
  fill: var(--haus-stockStatus__dotInStock__fill, #8adec2);
}

.dotLowStock circle {
  fill: var(--haus-stockStatus__dotLowStock__fill, #f5a623);
}

.dotOutOfStock circle {
  fill: var(--haus-stockStatus__dotOutOfStock__fill, #eb6c6e);
}

.text {
  font-size: var(--haus-stockStatus__text__font-size, inherit);
}
